import { CommonApiTypes } from 'models/Common/commonApiTypes';

export enum DeviceKeyErrorCode {
    INVALID_KEY = 1100,
    EXPIRED = 1101,
}

export interface GetVerifyAiAccessResponse {
    data: {
        model: string;
        maxTokens: number;
        apiKey: string;
    };
}

export interface GetDiagnosisListResponse extends CommonApiTypes {
    data: { list: GetAssessmentAiResultResponse[]; token: string };
}

export interface GetDeviceKeyCountResponse extends CommonApiTypes {
    count: number;
}

export interface GetAssessmentAiResultResponse extends CommonApiTypes {
    data: {
        emrNumber: string;
        _id: string;
        patientName: string;
        patientId: string;
        parentName: string;
        patientCode: string;
        patientMobile: string;
        patientIdentityNumber: string;
        patientGender: 'male' | 'female'; // male만 주어졌지만, female도 고려
        hospitalId: string;
        hospitalName: string;
        doctorName: string;
        doctorId: string;
        status: number;
        gradeName: string;
        gradeCode: string;
        counselDateTimeList: string[];
        assessmentList: {
            _id: string;
            assessmentCode: string;
            subName: string;
            group: string;
            assessmentName: string;
            targetAge: string;
            questionCount: number;
            maxNoResCount: number;
            elapsedTime: number;
            status: number;
            tags: string[];
            maxAgeMonth: number;
            minAgeMonth: number;
        }[];
        diagnosisDateTime: string;
        diagnosisTimestamp: number;
        assessmentAge: string;
        diagnosisMemo: string;
        prescriptionMemo: string;
        relationType: number;
        timestamp: number;
        voucherCode: string;
        counselReason: string;
        noShowInfo: {
            noShowTimestamp: number;
            noShowReason: string;
            newCounselDateTime: string;
        }[];
        assessmentAiResult: {
            totalResult: {
                targetResult: {
                    target: string;
                    character: string;
                    description: string;
                }[];
                conclusion: string;
            };
            summaryList: {
                target: string;
                englishTitle: string;
                koreanTitle: string;
                description: string;
            }[];
            recommendList: {
                keyword: string;
                description: string;
            }[];
            chatMessageList: {
                role: 'user' | 'assistant';
                text: string;
                chatTimestamp: number;
            }[];
        };
        deviceKey?: string;
    };
}
